import Vue from 'vue'
import PhoneVerify from './PhoneVerify.vue'

const PhoneVerifyComponent = Vue.extend(PhoneVerify)
let vm = null

export default {
  install(Vue, Options) {
    

    Vue.prototype.$phoneVerify = {
      async show(opts) {
        const res = await asyncPhoneVerify(opts);
        return res;
      }
    }
  }
}

export function asyncPhoneVerify(params) {
  return new Promise((resolve, reject) => {
    vm = new PhoneVerifyComponent({
      el: document.createElement('div')
    })
    Object.assign(vm, params)
    document.body.appendChild(vm.$el)
    vm.$on('confirm', (res) => {
      resolve(res)
      vm.modalShow = false
    })
    vm.$on('close', () => {
      reject(new Error('cancel'))
      vm.modalShow = false
      document.body.removeChild(vm.$el)
    })
  });
}